import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  subjects: [],
  tmp: null,
};

const getters = {
  getSubjects: (state) => state.subjects,
  getSubjectById: (state) => (id) => state.subjects.find((x) => x.id == id),
};

const actions = {
  async uploadSubjectsFile({ commit }, file) {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const resp = await api.post("/subjects/import", formData);
      //console.log("resp", resp);
      if (resp.status == 200) {
        //console.log("done uploaded");
        commit("dooTemp", 1);
        return true;
      }
    } catch (error) {
      //console.log("error", error);
      return false;
    }
  },
  async fetchSubjects({ commit }) {
    try {
      const resp = await api.get("/subjects");
      if (resp.status == 200) {
        const subjects = resp.data.data.subjects;
        //console.log("subjects", subjects);
        commit("setSubjects", subjects);
      }
    } catch (error) {
      //console.log("error", error);
      return false;
    }
  },
  async updateSubject({ commit }, subject) {
    //console.log("xxx:", subject);
    try {
      const id = subject.id;
      subject._method = "patch";

      const resp = await api.post(`/subjects/${id}`, subject);
      console.log("subject", subject);
      if (resp.status == 200) {
        const subject = resp.data.data;
        commit("updateSubject", subject);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      //console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addSubject({ commit }, subject) {
    console.log("subject", subject);
    try {
      const resp = await api.post(`/subjects`, subject);

      if (resp.status == 201) {
        const subject = resp.data.data;

        commit("addSubject", subject);
      }
      //console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteSubject({ commit }, id) {
    try {
      const resp = await api.delete(`/subjects/${id}`);

      if (resp.status == 204) {
        commit("deleteSubject", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  dooTemp(state, x) {
    state.tmp = x;
  },
  setSubjects(state, subjects) {
    state.subjects = subjects;
  },
  updateSubject(state, subject) {
    const id = subject.id;
    const index = state.subjects.findIndex((subject) => subject.id == id);
    if (index !== -1) {
      state.subjects[index] = subject;
    }
  },
  addSubject(state, subject) {
    state.subjects.unshift(subject);
  },

  deleteSubject(state, id) {
    const index = state.subjects.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.subjects.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
